import type { DomainMapper } from '../types';

const se: DomainMapper = {
  countryCode: 'se',
  currency: 'SEK',
  dataAreaId: 'se01',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/SE.svg',
  languagePrimary: true,
  locale: 'sv',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-se.xml',
  storyblokBasePath: 'se',
  url: 'https://kahrs-preview.iveo.store/se',
  algoliaIndex: 'b2b-se-sv-SE-products',
  algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1155,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1155,
    algoliaIndex: 'b2b-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-se.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1473,
    algoliaIndex: 'b2c-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2c-se-sv-SE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-se-b2c.xml',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
  },
  showNonPublicProducts: false,
} as DomainMapper;

export default se;
